/**
 * A frase de erro que a tela mostra, venha de onde vier: tRPC (`TRPCClientError`, com `data.code`) ou do
 * upload REST (`ApiError`, com `status`).
 *
 * O servidor já escreve em português o que importa — "Imagem não encontrada", a recusa de falta de
 * transparência, "Só o administrador torna uma imagem pública ou privada" — e essas frases passam
 * intactas. Só se troca o que o servidor não sabe dizer por quem está diante de um celular: sessão
 * vencida, queda de rede e falha interna.
 */
export function mensagemDeErro(
  e: unknown,
  padrao = "Não foi possível concluir. Tente de novo.",
): string {
  const erro = (e ?? null) as {
    message?: unknown;
    status?: unknown;
    data?: { code?: unknown } | null;
  } | null;
  const mensagem = typeof erro?.message === "string" ? erro.message.trim() : "";
  const codigo = typeof erro?.data?.code === "string" ? erro.data.code : null;
  const status = typeof erro?.status === "number" ? erro.status : null;

  if (codigo === "UNAUTHORIZED" || status === 401) {
    return "Sua sessão acabou. Entre de novo para continuar.";
  }
  if (codigo === "INTERNAL_SERVER_ERROR" || codigo === "TIMEOUT" || (status ?? 0) >= 500) {
    return "O servidor teve um problema. Tente de novo em instantes; se continuar, avise o administrador.";
  }
  // "Sem conexão com o servidor" é a frase do próprio upload (`enviarArquivos`, evento `error` do XHR): sem o
  // que fazer, é só um diagnóstico.
  if (/failed to fetch|networkerror|load failed|sem conexão/i.test(mensagem)) {
    return "Sem conexão com o servidor. Confira a internet e tente de novo.";
  }
  // O que começa com `[` ou `{` é o JSON de uma validação do Zod: não é texto para ninguém.
  if (!mensagem || /^[[{]/.test(mensagem)) return padrao;
  return mensagem;
}
